import { Breadcrumb } from '@primer-io/goat'
import { HR } from 'components/ArticleComponents'
import Clickable from 'components/Clickable'
import Footer from 'components/Footer'
import Grid from 'components/Grid'
import Main from 'components/PageLayout/Main'
import { RightSidebar } from 'components/PageLayout/Sidebars'
import SEO from 'components/SEO'
import TableOfContents from 'components/TableOfContents'
import TopSection from 'components/TopSection'
import useBreadcrumbs from 'hooks/useBreadcrumbs'
import useTableOfContents from 'hooks/useTableOfContents'
import React from 'react'
import styled from 'styled-components'
import { TOCProvider } from '../TableOfContents/TOCContext'
import CamelCaseWrap from 'components/CamelCaseWrap'

const ContentContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
`

const Content = styled.div`
	margin-top: 48px;
	flex: 1;
	width: 0px;
	height: 100%;
	padding: 0px 24px 0px 48px;
	word-wrap: break-word;

	padding-left: 24px;
	transition: padding-left 300ms ease;
	${p => p.theme.above('large')`
		padding-left: 48px;
	`}

	${p => p.fullWidth && `padding-right: 0;`}

	${p => p.theme.above('extraLarge')`
    ${p =>
			!p.fullWidth &&
			`
    max-width: 840px;
    padding-bottom: 2rem;
    `}

    ${p => p.fullWidth && `max-width: calc(100vw - 344px);`}
  `}

	&::-webkit-scrollbar {
		width: 0 !important;
	}
`

const StyledBreadcrumb = styled(Breadcrumb)`
	margin-bottom: 24px;
`

export default function ArticleLayout({
	children,
	fullWidth,
	// hasPagination,
	hideTopSection,
	location,
	// modSlug,
	// pagination,
	seoProps,
	showBreadcrumbs,
	tableOfContentsMaxDepth,
	topSectionProps,
}) {
	const breadcrumbs = useBreadcrumbs(location)
	const tableOfContents = useTableOfContents([location.search, location.pathname])

	return (
		<>
			<SEO {...seoProps} />

			<TOCProvider value={{ tocValue: { items: tableOfContents } }}>
				<Main fullWidth={fullWidth}>
					<ContentContainer>
						<Content fullWidth={fullWidth}>
							{showBreadcrumbs && breadcrumbs && (
								<StyledBreadcrumb>
									{breadcrumbs.map(breadcrumb => (
										<Breadcrumb.Item key={breadcrumb.href} as={Clickable} to={breadcrumb.href}>
											<CamelCaseWrap text={breadcrumb.title} />
										</Breadcrumb.Item>
									))}
								</StyledBreadcrumb>
							)}
							{!hideTopSection && (
								<TopSection breadcrumbs={showBreadcrumbs ? breadcrumbs : undefined} {...topSectionProps} />
							)}
							<Grid.Row style={{ padding: 0, margin: 0 }}>
								<Grid.Column xs='span' style={{ padding: 0, margin: 0 }}>
									{children}
									{!fullWidth && (
										<>
											<HR />
											<div style={{ marginTop: 64 }}>
												<Footer />
											</div>
										</>
									)}
									{/* {hasPagination && <DocumentsPagination slug={modSlug} pagination={pagination} />} */}
								</Grid.Column>
							</Grid.Row>
						</Content>
						{!fullWidth && (
							<RightSidebar>
								<TableOfContents maxDepth={tableOfContentsMaxDepth} />
							</RightSidebar>
						)}
					</ContentContainer>
				</Main>
			</TOCProvider>
		</>
	)
}
